
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.5 2.324A2.245 2.245 0 102.323 5.5l1.03 1.03-.943.942-1.03-1.029a3.578 3.578 0 015.061-5.06l6.177 6.176a3.578 3.578 0 01-5.06 5.06l-2.317-2.316a2.486 2.486 0 113.516-3.516l1.287 1.287-.943.943-1.286-1.287a1.153 1.153 0 00-1.631 1.63L8.5 11.677A2.245 2.245 0 1011.676 8.5L5.499 2.324z","fill":"#4FAEAF"}})])
          )
        }
      }
    